import React from 'react';
import TopPaidEventContainer from '@src/containers/TopPaidEvent';

const TopPaidEvent = () => <TopPaidEventContainer />;

export default TopPaidEvent;
